export default __webpack_public_path__ + "NDChristie_Resume_2020b.pdf";